import { ReactNode } from "react";
import { useDroppable } from "@dnd-kit/core";
/* Prop Types */
interface DroppableProps {
  id: string;
  children: ReactNode;
  className?: string;
}

/*
 * Droppable component
 * A generic droppable area for use with dnd-kit drag-and-drop.
 */
export const DroppableWrapper = ({ id, children, className = "" }: DroppableProps) => {
  /* Hooks */
  const { setNodeRef } = useDroppable({ id });

  /* Render */
  return (
    <div ref={setNodeRef} className={className}>
      {children}
    </div>
  );
};
